import { useTiptapEditor } from '@/hooks/use-tiptap-editor';
import { isSelectionInsideZydefn } from '@/lib/tiptap-utils';
import { BookType } from 'lucide-react';
import { forwardRef, useCallback, useSyncExternalStore } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

const ZyTermButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => {
    const { editor } = useTiptapEditor(props.editor);

    const subscribe = useCallback(
        (onStoreChange: () => void) => {
            if (!editor) return () => {};
            editor.on('selectionUpdate', onStoreChange);
            return () => editor.off('selectionUpdate', onStoreChange);
        },
        [editor],
    );

    const getSnapshot = useCallback(() => isSelectionInsideZydefn(editor), [editor]);

    const isVisible = useSyncExternalStore(subscribe, getSnapshot);

    if (!editor || !isVisible) {
        return null;
    }

    return (
        <GenericExtensionButton
            extensionName="zydefTerm"
            extensionType="node"
            icon={BookType}
            label="ZyTerm"
            isActive={e => e.isActive('zydefTerm')}
            command={e => e.commands.toggleZydefTerm()}
            shortcutKeys="Mod+Alt+t"
            ref={ref}
            {...props}
        />
    );
});

ZyTermButton.displayName = 'ZyTermButton';

export default ZyTermButton;
